'use client';

import { MonoDefault, renderHttpBadge } from '@terra/ui-design-system';
import { Box, HStack } from '@terra/ui-styled-system';
import {
  getAssetMergeMethod,
  getAssetMergePath,
  type AssetMergeCandidate,
} from '../../utils/asset-merge/asset-merge-selection';

type AssetMergeSurvivorPickButtonProps = {
  asset: AssetMergeCandidate;
  isSuggested: boolean;
  onSelect: (assetId: string) => void;
};

export function AssetMergeSurvivorPickButton({
  asset,
  isSuggested,
  onSelect,
}: AssetMergeSurvivorPickButtonProps) {
  const path = getAssetMergePath(asset);
  const method = getAssetMergeMethod(asset);

  return (
    <Box
      as="button"
      w="full"
      minW={0}
      textAlign="start"
      cursor="pointer"
      bg="transparent"
      borderWidth="0"
      p="0"
      onClick={() => onSelect(asset.id)}
    >
      <HStack gap="2" alignItems="center" w="full" minW={0}>
        {method ? renderHttpBadge(method) : null}
        <MonoDefault
          wordBreak="break-word"
          fontWeight={isSuggested ? 'bold' : 'normal'}
        >
          {path}
        </MonoDefault>
      </HStack>
    </Box>
  );
}
